/* eslint-disable jsx-a11y/aria-proptypes */
/* eslint-disable prettier/prettier */
'use client';

import { LinkField, LinkFieldValue } from '@sitecore-content-sdk/nextjs';
import LinkWrapper from '../LinkWrapper/LinkWrapper';
import { CtaVariants } from 'lib/utils/style-param-utils/modules/ctas';
import useIsEditing from 'lib/hooks/useIsEditing';
import { JSX } from 'react';

export interface ButtonGroupProps {
  WrapperClasses?: string;
  ButtonWrapperClasses?: string;
  TextWrapperClasses?: string;
  editable?: boolean;
  hideCta3Icon?: boolean;
  sidebysideCta3?: boolean;
  isHashLink?: boolean;
  fields: {
    cta1?: LinkField | LinkFieldValue;
    cta2?: LinkField | LinkFieldValue;
    cta3?: { fields: { link: LinkField | LinkFieldValue } }[];

    cta1Variant?: {
      value: string;
    };
    cta2Variant?: {
      value: string;
    };
    cta3Variant?: {
      value: string;
    };
  };
}

const ButtonGroup = ({
  WrapperClasses,
  ButtonWrapperClasses,
  TextWrapperClasses,
  hideCta3Icon = false,
  sidebysideCta3 = false,
  isHashLink = false,
  ...props
}: ButtonGroupProps): JSX.Element => {
  const isEditing = useIsEditing();
  type Cta3Item = { fields: { link: LinkField | LinkFieldValue } };

  const cta3List: Cta3Item[] | undefined = props?.fields?.cta3;

  const cta1HasHref = !!(props?.fields?.cta1 as LinkField)?.value?.href;
  const cta2HasHref = !!(props?.fields?.cta2 as LinkField)?.value?.href;

  const hasCta3Links = cta3List?.some(
    (cta3) => !!(cta3?.fields?.link as LinkField)?.value?.href
  )

  const shouldRenderWrapper = cta1HasHref || cta2HasHref || hasCta3Links;

  return (
    <>
    {isEditing ? ( 
      <div className={`flex ${WrapperClasses}`}>
        <div className={`flex flex-wrap gap-8 ${ButtonWrapperClasses}`}>
          <LinkWrapper
            field={props?.fields?.cta1}
            {...(props?.fields?.cta1Variant?.value?.toLowerCase() === 'tertiary' && { ctaIcon: 'arrow-right' })}
            ctaVariant={props?.fields?.cta1Variant?.value.toLowerCase() as CtaVariants}
            className={`${sidebysideCta3 || props?.fields?.cta3Variant?.value?.toLowerCase() === 'jumplink' ? "w-fit" : "md:w-fit w-full"}`}
          />
          <LinkWrapper
            field={props?.fields?.cta2}
            {...(props?.fields?.cta2Variant?.value?.toLowerCase() === 'tertiary' && { ctaIcon: 'arrow-right' })}
            ctaVariant={props?.fields?.cta2Variant?.value.toLowerCase() as CtaVariants}
            className={`${sidebysideCta3 || props?.fields?.cta3Variant?.value?.toLowerCase() === 'jumplink' ? "w-fit" : "md:w-fit w-full"}`}
          />
        </div>

        <ul
          className={`${sidebysideCta3 || props?.fields?.cta3Variant?.value?.toLowerCase() === 'jumplink' ? 'flex flex-row flex-wrap gap-x-8 lg:gap-y-8' : 'flex flex-col md:flex-row flex-wrap gap-x-8 gap-y-6'}  ${TextWrapperClasses}`}
        >
          {cta3List?.map((cta3, index: number) => {
            return (
              <li
              className={`${sidebysideCta3 || props?.fields?.cta3Variant?.value?.toLowerCase() === 'jumplink' ? 'w-auto lg:mb-0 mb-8 flex justify-start' : 'lg:w-auto w-fit'} `}
                key={index}
              >
                <LinkWrapper
                  field={cta3?.fields?.link as LinkField | LinkFieldValue}
                  ctaVariant={
                    props?.fields?.cta3Variant?.value
                      .toLowerCase()
                      .replaceAll(' ', '') as CtaVariants
                  }
                  className={`${sidebysideCta3 || props?.fields?.cta3Variant?.value?.toLowerCase() === 'jumplink' ? 'w-fit' : 'lg:w-fit w-full'}`}
                  {...(!hideCta3Icon && { ctaIcon: 'arrow-right' })}
                  isHashLink={isHashLink}
                />
              </li>
            );
          })}
        </ul>
      </div>
    ) :  (
    shouldRenderWrapper && <div className={`flex ${WrapperClasses}`}>
         {(cta1HasHref || cta2HasHref) && (<div className={`flex flex-wrap gap-8 ${ButtonWrapperClasses}`}>
          {cta1HasHref && ( <LinkWrapper
            field={props?.fields?.cta1}
            {...(props?.fields?.cta1Variant?.value?.toLowerCase() === 'tertiary' && { ctaIcon: 'arrow-right' })}
            ctaVariant={props?.fields?.cta1Variant?.value.toLowerCase().replaceAll(' ', '') as CtaVariants}
            className={`${sidebysideCta3 || props?.fields?.cta3Variant?.value?.toLowerCase() === 'jumplink' ? "w-fit" : "md:w-fit w-full"}`}
          />)}
         {cta2HasHref && ( <LinkWrapper
            field={props?.fields?.cta2}
            {...(props?.fields?.cta2Variant?.value?.toLowerCase() === 'tertiary' && { ctaIcon: 'arrow-right' })}
            ctaVariant={props?.fields?.cta2Variant?.value.toLowerCase().replaceAll(' ', '') as CtaVariants}
            className={`${sidebysideCta3 || props?.fields?.cta3Variant?.value?.toLowerCase() === 'jumplink' ? "w-fit" : "md:w-fit w-full"}`}
          />)}
        </div>)}

        {hasCta3Links && ( <ul
          className={`${sidebysideCta3 || props?.fields?.cta3Variant?.value?.toLowerCase() === 'jumplink' ? 'flex flex-row flex-wrap gap-x-8 lg:gap-y-8' : 'flex flex-col md:flex-row flex-wrap gap-x-8 gap-y-6'}  ${TextWrapperClasses}`}
        >
          {cta3List?.map((cta3, index: number) => {
            return (
              <li
                className={`${sidebysideCta3 || props?.fields?.cta3Variant?.value?.toLowerCase() === 'jumplink' ? 'w-auto lg:mb-0 mb-8 flex justify-start' : 'lg:w-auto w-fit'} `}
                key={index}
              >
                <LinkWrapper
                  field={cta3?.fields?.link as LinkField | LinkFieldValue}
                  ctaVariant={
                    props?.fields?.cta3Variant?.value
                      .toLowerCase()
                      .replaceAll(' ', '') as CtaVariants
                  }
                  className={`${sidebysideCta3 || props?.fields?.cta3Variant?.value?.toLowerCase() === 'jumplink' ? 'w-fit' : 'lg:w-fit w-full'}`}
                  {...(!hideCta3Icon && { ctaIcon: 'arrow-right' })}
                  isHashLink={isHashLink}
                />
              </li>
            );
          })}
        </ul>)}
    </div>
    )
    }
    </>
  );
};

export default ButtonGroup;
